export default "__VITE_ASSET__CaOKN4MN__"